export const STATE_PROP = 'companiesDisplays'
